<mat-chip-listbox hideSingleSelectionIndicator class="status-chip-container">
  <mat-chip-option 
    class="status-chip" 
    [ngClass]="[statusName]"
  >
    {{ translationKey | translate }}
  </mat-chip-option>
</mat-chip-listbox>